import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { EmptyComponent } from '../../../app/components/empty/empty.component';
import { IonicModule } from '@ionic/angular';
import { AppointmentContainerComponent } from '../../../app/components/appointment-container/appointment-container.component';
import { InvoiceComponent } from '../../../app/components/invoice/invoice.component';
import { PaymentItemComponent } from '../../../app/components/payment-item/payment-item.component';
import { OnboardingStepComponentComponent } from '../../../app/components/onboarding-step-component/onboarding-step-component.component';
import { LoaderButtonComponent } from '../../../app/components/loader-button/loader-button.component';
import { SubscriptionPlanComponent } from '../../../app/components/subscription-plan/subscription-plan.component';
import { OnboardingTooltipComponent } from '../../../app/components/onboarding-tooltip/onboarding-tooltip.component';
import { OnboardingTriggerComponent } from '../../../app/components/onboarding-trigger/onboarding-trigger.component';



@NgModule({
  declarations: [
    EmptyComponent,
    AppointmentContainerComponent,
    InvoiceComponent,
    PaymentItemComponent,
    OnboardingStepComponentComponent,
    LoaderButtonComponent,
    SubscriptionPlanComponent,
    OnboardingTooltipComponent,
    OnboardingTriggerComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    HttpClientModule,
  ],
  exports: [
    TranslateModule,
    HttpClientModule,
    EmptyComponent,
    AppointmentContainerComponent,
    InvoiceComponent,
    PaymentItemComponent,
    OnboardingStepComponentComponent,
    LoaderButtonComponent,
    SubscriptionPlanComponent,
    OnboardingTooltipComponent,
    OnboardingTriggerComponent
  ]
})
export class SharedModule { }
